import { t } from "@lingui/macro";
import { Cookie, Gear } from "@phosphor-icons/react";
import { Button } from "@reactive-resume/ui";

import { useCookieStore } from "@/client/stores/cookie";

export const CookieBanner = () => {
  const { consent, setModalOpen } = useCookieStore();

  // Only show banner if consent has been given
  if (!consent) return null;

  return (
    <div className="fixed right-4 bottom-4 z-40">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setModalOpen(true)}
        className="flex size-12 items-center gap-2 rounded-full text-black shadow-lg backdrop-blur-sm"
      >
        <Cookie className="h-5 w-5" />
      </Button>
    </div>
  );
};
